import { render, staticRenderFns } from "./HrAboutStats.vue?vue&type=template&id=6312ef3e"
import script from "./HrAboutStats.vue?vue&type=script&lang=js"
export * from "./HrAboutStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports